import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// Initialisation GA4
const GA_MEASUREMENT_ID = 'G-DPR93641WZ';
ReactGA.initialize(GA_MEASUREMENT_ID);

// Composant tracker
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search + location.hash 
    });
    
    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Page view sent to GA:', location.pathname);
    }
  }, [location]);

  return null;
}

// Composant wrapper pour avoir accès à useLocation
function AppWithTracker() {
  return (
    <>
      <PageTracker />
      <AppRoutes />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppWithTracker />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;